import { DocumentIdentifier } from "../document.model";

export class Remark {
    DocumentIdentifier: DocumentIdentifier = new DocumentIdentifier();
    Content: string = "";
    AllowAdds: boolean = true;

    public constructor(rem: Remark) {
        this.DocumentIdentifier = rem.DocumentIdentifier;
        this.Content = rem.Content;
        this.AllowAdds = rem.AllowAdds;
    }
}
